import { type AuthUser } from '@gb-ticket/shared-types';
import { ExternalLinkIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DashboardPanel } from '@/products/helpdesk/features/dashboard/dashboard-panel';
import { dashboardSecurityLinks } from '@/products/helpdesk/features/dashboard/dashboard-security-links';

export function SecurityDashboardPanel({ user: _user }: { user: AuthUser }) {
  const links = dashboardSecurityLinks();

  return (
    <DashboardPanel
      slotId="security"
      title="Security"
      description="Identität und Sicherheit über Microsoft-Portale — ohne Live-Anbindung im Mitarbeiterportal."
    >
      <ul className="flex flex-col gap-2">
        {links.map((link) => (
          <li key={link.id}>
            <Button asChild variant="outline" className="h-auto w-full justify-between px-3 py-2">
              <a href={link.url} target="_blank" rel="noopener noreferrer">
                <span>{link.label}</span>
                <ExternalLinkIcon className="size-4 shrink-0 text-muted-foreground" aria-hidden />
                <span className="sr-only"> (öffnet extern)</span>
              </a>
            </Button>
          </li>
        ))}
      </ul>
    </DashboardPanel>
  );
}
